import { createVNode, render } from 'vue'
import toastTemplate from './Toast'

export interface IProps {
  visible?: string
  duration?: number
  icon?: string
  tip?: string
}
const defaultOpt = { // 创建默认参数
  visible: true,
  icon: '',
  tip: '链接失效',
  duration: 3000,
}

export interface ResultParams {
  destory?: () => void
}

const Toast = (options: IProps): ResultParams => {
  const container = document.createElement('div')
  const opt = { ...defaultOpt, ...options }
  const vm = createVNode(toastTemplate, opt) // 创建vNode
  render(vm, container)
  document.body.appendChild(container) // 添加到body上
  const destory = () => {
    const dom = vm.el as HTMLDivElement
    if (dom.querySelector('.toast-value')) {
      const t = setTimeout(() => { // 淡入淡出效果之后删除dom节点
        render(null, container)
        document.body.removeChild(container)
        clearTimeout(t)
      }, 500)
    }
  }
  if (opt.duration) { // 如果传入的值为0可以持续保留在页面，需要手动销毁
    const timer = setTimeout(() => {
      destory()
      clearTimeout(timer)
    }, opt.duration)
  }
  return {
    destory,
  }
}
export default Toast
